//import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthProvider';
import { QueryParamsProvider } from './context/QueryParamsProvider';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import OfflineIndicator from './OfflineIndicator';
import { Detector, Offline, Online } from "react-detect-offline";

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <BrowserRouter basename={baseUrl}>
        <AuthProvider>
            <QueryParamsProvider>
                <SkeletonTheme baseColor="#ebebed" highlightColor="#f5f5fa">
                    {/*<OfflineIndicator />*/}
                    <Detector
                        polling={{
                            //url: `http://${document.location.host}`,
                            url: `https://${document.location.host}`,
                            interval: 3000, // Polling interval in milliseconds (e.g., every 3 seconds)
                            timeout: 5000, // Timeout for each polling request in milliseconds
                        }}
                        render={({ online }) => (
                            !online ? <OfflineIndicator />:null
                        )}
                    />
                    <App />
                </SkeletonTheme>
            </QueryParamsProvider>
        </AuthProvider>
    </BrowserRouter>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
